import { inject } from '@angular/core';
import { CanActivateFn, Route, Router } from '@angular/router';
import { ZardSonnerService } from '../components/ui/sonner/sonner.service';

/**
 * Grenze zum Telefon. Darüber liegt das Tablet, das seit `daba4ca` den
 * Arbeitsbereich bekommt — die Reduktion hier gilt nur für das Telefon.
 */
export const PHONE_MAX_WIDTH = 768;

export function isPhoneWidth(width: number = window.innerWidth): boolean {
  return width < PHONE_MAX_WIDTH;
}

/**
 * Ob eine Route auf dem Telefon geführt wird.
 *
 * Standard ist „ja": ein Modul sperrt sich ausdrücklich mit `mobile: false` in
 * seinen Routendaten, damit ein neues Modul nicht versehentlich verschwindet.
 */
export function isRouteOnPhone(route: Route): boolean {
  return route.data?.['mobile'] !== false;
}

/**
 * Sperrt die Verwaltungsmodule auf dem Telefon.
 *
 * Sie aus der Rail zu nehmen genügt nicht: Lesezeichen, Verlauf und alte Links
 * führen weiter hinein, und dort steht eine Oberfläche, die auf 390 px nicht zu
 * bedienen ist.
 */
export const phoneBlockedGuard: CanActivateFn = (route) => {
  if (!isPhoneWidth() || route.data['mobile'] !== false)
    return true;

  inject(ZardSonnerService).info('Nicht auf dem Telefon', {
    description: `${route.data?.['navLabel'] ?? 'Dieser Bereich'} steht am Rechner oder Tablet bereit.`,
  });

  return inject(Router).createUrlTree(['/']);
};
